import {
  Modal as ModalMui,
  Paper as PaperMui,
  Typography,
  Button as ButtonMui,
  IconButton as IconButtonMui,
  styled,
} from '@material-ui/core'

export const Modal = styled(ModalMui)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
})

export const Paper = styled(PaperMui)({
  width: '100%',
  maxWidth: '960px',
  maxHeight: '92vh',
  overflow: 'hidden',
  padding: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
})

export const CloseButton = styled(IconButtonMui)({
  color: '#757575',
  margin: '-.5rem -.5rem 0 1rem',
  '&:hover': {
    backgroundColor: '#F3F5F1',
    color: '#353535',
  },
})

export const OrderList = styled('div')({
  maxHeight: '300px',
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  paddingRight: '.5rem',
  marginRight: '-.5rem',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#C9CEC3',
    borderRadius: '6px',
  },
})

export const Title = styled(Typography)({
  color: '#353535',
  fontWeight: 500,
  fontSize: '1.2rem',
  marginBottom: '0.5rem',
})

export const Subtitle = styled(Typography)({
  color: '#757575',
  fontWeight: 500,
  fontSize: '1.2rem',
  marginBottom: '2rem',
})

export const Text = styled(Typography)({
  fontSize: '1.2rem',
  marginTop: '8px',
  color: '#757575',
})

export const Button = styled(ButtonMui)({
  width: 'auto',
  minWidth: '160px',
  marginTop: '2rem',
  color: '#757575',
  border: '1px solid #757575',
  minHeight: '40px',
  borderRadius: '20px',
  textTransform: 'none',
  '@media (max-width: 600px)': {
    width: '100%',
  },
})

export const ButtonBack = styled(Button)({
  border: 'none !important',
})

export const ButtonConfirm = styled(Button)({
  border: 'none !important',
  color: '#FFF',
  backgroundColor: '#89BD23',
  '&:hover': {
    backgroundColor: '#6F9D12',
  },
  '&.Mui-disabled': {
    color: '#A5A5A5',
    backgroundColor: '#F1F1F1',
  },
})
